import { Empty } from 'antd';
import type { ReactNode } from 'react';

interface Props {
  title?: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title = '暂无数据', description, action }: Props) {
  return (
    <div style={{ padding: 'var(--space-10) var(--space-4)', textAlign: 'center' }}>
      <Empty
        description={
          <div>
            <div style={{ fontSize: 'var(--font-size-md)', color: 'var(--color-text-primary)' }}>
              {title}
            </div>
            {description && (
              <div
                style={{
                  marginTop: 4,
                  fontSize: 'var(--font-size-sm)',
                  color: 'var(--color-text-secondary)',
                }}
              >
                {description}
              </div>
            )}
          </div>
        }
      />
      {action && <div style={{ marginTop: 'var(--space-4)' }}>{action}</div>}
    </div>
  );
}
